<template>
    <div class="input-group">
        <div class="input-group-prepend">
            <span class="input-group-text">
                <i class="far fa-calendar-alt"></i>
            </span>
        </div>
        <input type="text" class="form-control float-right calendario" :placeholder="this.placeholder || 'mm/dd/yyyy'"/>
    </div>
</template>

<script>
import { format } from 'date-fns';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.css';
import 'jquery.inputmask/dist/jquery.inputmask.bundle';

export default {
    props: ['value', 'placeholder'],
    mounted: function () {
        const vm = this;

        $(this.$el).find("input")
        .val(this.value)
        .datepicker({
            clearBtn: true,
            todayBtn: 'linked',
            todayHighlight: true,
            format: "mm/dd/yyyy",
            autoclose: true,
            changeYear: true
        }).on("changeDate", function() {
            vm.$emit('input', this.value);
        });

        $(this.$el).find("input").inputmask('mm/dd/yyyy', { 'placeholder': 'mm/dd/yyyy' });
    },
    watch: {
        value: function (value) {
            if(!value){
                return;
            }

            const regex = /^\d{2}\/\d{2}\/\d{4}$/;

            var dataFormatada = value;
            
            if(!regex.test(dataFormatada))
            {
                dataFormatada = format(new Date(dataFormatada), 'MM/dd/yyyy');
            }

            $(this.$el).find("input").datepicker("setDate", dataFormatada);
            $(this.$el).find("input").val(dataFormatada).trigger('change');
        }
    },
    destroyed: function () {
        $(this.$el).find("input").datepicker('destroy');
        $(this.$el).find("input").inputmask('remove');
    }
};
</script>